import { useClientTranslation } from '@/lib/core/i18n';
import { useApp } from '@/lib/core/providers/appProvider';
import { cn, getFirstName } from '@/lib/core/utils';

interface AssistanceProps {
  title: string;
  description: string;
  descriptionForMember?: string;
  className?: string | undefined;
}

export function Assistance({ title, description, descriptionForMember, className }: AssistanceProps) {
  const t = useClientTranslation();
  const { user } = useApp();
  const isMember = !!user?.hasActiveMembership;
  const userName = isMember ? getFirstName(user.name) : undefined;
  const resolvedDescription = (isMember && descriptionForMember ? descriptionForMember : description).replace(
    '{{concierge}}',
    isMember ? t('App.Labels.AssistanceConciergeLabel') : t('App.Labels.AssistanceCustomerServiceLabel')
  );

  return (
    <div className={cn('font-pp-neue-montreal flex w-full flex-col gap-4 tracking-[0.5px]', className)}>
      <p className="text-jncquoi-neutral-1000 text-[14px] font-normal">
        {title}
        {userName ? (
          <>
            {', '}
            <span className="font-semibold">{userName}?</span>
          </>
        ) : (
          '?'
        )}
      </p>
      <p className="text-[12px] text-[#666]">{resolvedDescription}</p>
    </div>
  );
}
